// Simple localStorage-backed cache for symbol price digits per account.
// Keyed by `${accountId||'global'}:${symbol.toUpperCase()}`

const STORAGE_KEY = 'symbolDigits:v1';
let mem = null;

function load() {
  if (mem) return mem;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    mem = raw ? JSON.parse(raw) : {};
  } catch (_) {
    mem = {};
  }
  return mem;
}

function persist() {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(mem || {}));
  } catch (_) {}
}

function keyFor(accountId, symbol) {
  if (!symbol) return null;
  const sym = String(symbol).toUpperCase();
  const acc = accountId ? String(accountId) : 'global';
  return `${acc}:${sym}`;
}

export function getDigitsFor(accountId, symbol) {
  const k = keyFor(accountId, symbol);
  if (!k) return undefined;
  const db = load();
  const v = db[k];
  return typeof v === 'number' ? v : undefined;
}

export function setDigitsFor(accountId, symbol, digits) {
  const k = keyFor(accountId, symbol);
  if (!k) return;
  const d = Number(digits);
  if (!Number.isFinite(d) || d < 0 || d > 12) return; // guard
  const db = load();
  db[k] = d;
  persist();
}

export function clearDigitsFor(accountId, symbol) {
  const k = keyFor(accountId, symbol);
  if (!k) return;
  const db = load();
  if (db && Object.prototype.hasOwnProperty.call(db, k)) {
    delete db[k];
    persist();
  }
}

export function getAllDigits() {
  return { ...(load() || {}) };
}
